export default {
  lead_modal: {
    title: '📩 Preis und Verfügbarkeit anfragen',
    subtitle:
      'Preis und Status können sich ändern. Hinterlassen Sie Ihre Kontaktdaten — ein Makler bestätigt die aktuellen Bedingungen.',

    name: 'Ihr Name',
    contact: 'WhatsApp-Nummer',
    message: 'Nachricht (optional)',

    cancel: 'Abbrechen',
    submit: 'Senden',
    sending: 'Wird gesendet…',

    success: 'Anfrage gesendet!',
    error_unknown: 'Unbekannter Fehler'
  }
}
